module.exports = __webpack_public_path__ + "assets/img/ythbf.1786e69f.png";